export function AllowlistIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40.3498 28.6701C40.3498 37.6401 33.0698 44.9301 24.0998 44.9301C15.7198 44.9301 8.82978 38.6001 7.93978 30.4701C7.92978 30.4201 7.91978 30.3801 7.91978 30.3301C7.09978 25.2801 8.27978 17.1401 9.18978 12.1801C9.59978 9.97008 12.0098 8.79008 13.9998 9.83008C14.5998 10.1501 15.2398 10.4901 15.9198 10.8501C17.2598 8.81008 18.5998 6.92008 19.7998 5.27008C21.9198 2.35008 26.2698 2.35008 28.3898 5.27008C33.2098 11.8901 40.3498 22.7101 40.3498 28.6701Z"
        fill="url(#paint0_linear_2619_966)"
      />
      <path
        d="M40.3498 28.6701C40.3498 37.6401 33.0698 44.9301 24.0998 44.9301C15.7198 44.9301 8.82978 38.6001 7.93978 30.4701C7.92978 30.4201 7.91978 30.3801 7.91978 30.3301C7.09978 25.2801 8.27978 17.1401 9.18978 12.1801C9.59978 9.97008 12.0098 8.79008 13.9998 9.83008C14.5998 10.1501 15.2398 10.4901 15.9198 10.8501C17.2598 8.81008 18.5998 6.92008 19.7998 5.27008C21.9198 2.35008 26.2698 2.35008 28.3898 5.27008C33.2098 11.8901 40.3498 22.7101 40.3498 28.6701Z"
        fill="url(#paint1_linear_2619_966)"
      />
      <path
        d="M34.1401 29.6799C34.1401 35.4999 29.4201 40.2199 23.6001 40.2199C17.7801 40.2199 13.0601 35.4999 13.0601 29.6799C13.0601 26.4899 16.2301 21.1399 19.0901 16.9499C21.2601 13.7699 25.9501 13.7699 28.1201 16.9499C30.9801 21.1399 34.1501 26.4899 34.1501 29.6799H34.1401Z"
        fill="url(#paint2_linear_2619_966)"
      />
      <mask
        id="path-3-outside-1_2619_966"
        maskUnits="userSpaceOnUse"
        x="17.6411"
        y="23.1321"
        width="12"
        height="12"
        fill="black"
      >
        <rect fill="white" x="17.6411" y="23.1321" width="12" height="12" />
        <path d="M23.5903 24.1321C24.1927 24.1321 24.682 24.6206 24.6821 25.2229V27.9993H27.4585C28.0607 27.9996 28.5483 28.4879 28.5483 29.0901C28.5483 29.6923 28.0606 30.1806 27.4585 30.1809H24.6821V32.9573C24.6821 33.5597 24.1927 34.0481 23.5903 34.0481C22.9881 34.0479 22.4996 33.5595 22.4995 32.9573V30.1809H19.7319C19.1297 30.1807 18.6411 29.6924 18.6411 29.0901C18.6411 28.4878 19.1297 27.9995 19.7319 27.9993H22.4995V25.2229C22.4996 24.6207 22.9882 24.1323 23.5903 24.1321Z" />
      </mask>
      <path
        d="M23.5903 24.1321C24.1927 24.1321 24.682 24.6206 24.6821 25.2229V27.9993H27.4585C28.0607 27.9996 28.5483 28.4879 28.5483 29.0901C28.5483 29.6923 28.0606 30.1806 27.4585 30.1809H24.6821V32.9573C24.6821 33.5597 24.1927 34.0481 23.5903 34.0481C22.9881 34.0479 22.4996 33.5595 22.4995 32.9573V30.1809H19.7319C19.1297 30.1807 18.6411 29.6924 18.6411 29.0901C18.6411 28.4878 19.1297 27.9995 19.7319 27.9993H22.4995V25.2229C22.4996 24.6207 22.9882 24.1323 23.5903 24.1321Z"
        fill="white"
      />
      <path
        d="M23.5903 24.1321V23.2765L23.59 23.2765L23.5903 24.1321ZM24.6821 25.2229H25.5377V25.2227L24.6821 25.2229ZM24.6821 27.9993H23.8266C23.8266 28.4718 24.2096 28.8548 24.6821 28.8548V27.9993ZM27.4585 27.9993L27.459 27.1437H27.4585V27.9993ZM28.5483 29.0901L29.4039 29.0901V29.0901H28.5483ZM27.4585 30.1809V31.0364L27.459 31.0364L27.4585 30.1809ZM24.6821 30.1809V29.3254C24.2096 29.3254 23.8266 29.7084 23.8266 30.1809H24.6821ZM24.6821 32.9573L25.5377 32.9573V32.9573H24.6821ZM23.5903 34.0481L23.59 34.9036H23.5903V34.0481ZM22.4995 32.9573H21.644V32.9573L22.4995 32.9573ZM22.4995 30.1809H23.3551C23.3551 29.7084 22.972 29.3254 22.4995 29.3254V30.1809ZM19.7319 30.1809L19.7316 31.0364H19.7319V30.1809ZM18.6411 29.0901H17.7856V29.0901L18.6411 29.0901ZM19.7319 27.9993V27.1437L19.7316 27.1437L19.7319 27.9993ZM22.4995 27.9993V28.8548C22.972 28.8548 23.3551 28.4718 23.3551 27.9993H22.4995ZM22.4995 25.2229L21.644 25.2227V25.2229H22.4995ZM23.5903 24.1321V24.9876C23.721 24.9876 23.8266 25.0939 23.8266 25.2231L24.6821 25.2229L25.5377 25.2227C25.5375 24.1472 24.6644 23.2765 23.5903 23.2765V24.1321ZM24.6821 25.2229H23.8266V27.9993H24.6821H25.5377V25.2229H24.6821ZM24.6821 27.9993V28.8548H27.4585V27.9993V27.1437H24.6821V27.9993ZM27.4585 27.9993L27.458 28.8548C27.5875 28.8549 27.6928 28.9598 27.6928 29.0901H28.5483H29.4039C29.4039 28.0159 28.5338 27.1443 27.459 27.1437L27.4585 27.9993ZM28.5483 29.0901L27.6928 29.0901C27.6928 29.2204 27.5875 29.3253 27.458 29.3254L27.4585 30.1809L27.459 31.0364C28.5338 31.0359 29.4039 30.1643 29.4039 29.0901L28.5483 29.0901ZM27.4585 30.1809V29.3254H24.6821V30.1809V31.0364H27.4585V30.1809ZM24.6821 30.1809H23.8266V32.9573H24.6821H25.5377V30.1809H24.6821ZM24.6821 32.9573L23.8266 32.9572C23.8266 33.0862 23.7212 33.1926 23.5903 33.1926V34.0481V34.9036C24.6643 34.9036 25.5376 34.0331 25.5377 32.9573L24.6821 32.9573ZM23.5903 34.0481L23.5907 33.1926C23.4604 33.1925 23.3551 33.0868 23.3551 32.9572L22.4995 32.9573L21.644 32.9573C21.6441 34.0323 22.5158 34.9032 23.59 34.9036L23.5903 34.0481ZM22.4995 32.9573H23.3551V30.1809H22.4995H21.644V32.9573H22.4995ZM22.4995 30.1809V29.3254H19.7319V30.1809V31.0364H22.4995V30.1809ZM19.7319 30.1809L19.7323 29.3254C19.602 29.3253 19.4967 29.2196 19.4967 29.0901L18.6411 29.0901L17.7856 29.0901C17.7856 30.1652 18.6574 31.036 19.7316 31.0364L19.7319 30.1809ZM18.6411 29.0901H19.4967C19.4967 28.9606 19.6019 28.8549 19.7323 28.8548L19.7319 27.9993L19.7316 27.1437C18.6574 27.1441 17.7856 28.015 17.7856 29.0901H18.6411ZM19.7319 27.9993V28.8548H22.4995V27.9993V27.1437H19.7319V27.9993ZM22.4995 27.9993H23.3551V25.2229H22.4995H21.644V27.9993H22.4995ZM22.4995 25.2229L23.3551 25.2231C23.3551 25.0934 23.4606 24.9877 23.5907 24.9876L23.5903 24.1321L23.59 23.2765C22.5158 23.277 21.6442 24.148 21.644 25.2227L22.4995 25.2229Z"
        fill="url(#paint3_linear_2619_966)"
        fillOpacity="0.48"
        mask="url(#path-3-outside-1_2619_966)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2619_966"
          x1="23.9905"
          y1="2.59385"
          x2="23.9905"
          y2="47.4885"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#91FF70" />
          <stop offset="0.32" stopColor="#77FF84" />
          <stop offset="0.98" stopColor="#37FFBA" />
          <stop offset="1" stopColor="#36FFBC" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2619_966"
          x1="15.2473"
          y1="47.3041"
          x2="31.981"
          y2="6.25335"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4CFD11" />
          <stop offset="0.254462" stopColor="#17FC00" stopOpacity="0.92" />
          <stop offset="0.52" stopColor="#00FC00" stopOpacity="0.89" />
          <stop offset="1" stopColor="#B2FD0F" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2619_966"
          x1="12.8442"
          y1="50.0562"
          x2="31.9304"
          y2="18.2596"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#007900" />
          <stop offset="1" stopColor="#00C800" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2619_966"
          x1="18.6412"
          y1="29.0833"
          x2="28.5538"
          y2="29.0833"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8FFB3" />
          <stop offset="1" stopColor="#F0FEB7" />
        </linearGradient>
      </defs>
    </svg>
  )
}
